<template>
  <div class="expandCollapse">
    <div
      class="expandContent"
      :class="expandHeightstate ? 'expandHeightAuto' : ''"
    >
      <div class="expandMa" ref="expandma">
        <span class="span-name" v-if="expandTitle !== ''"
          >{{ expandTitle }}：</span
        >
        <span v-html="expandContent"></span>
      </div>
    </div>
    <div class="expandButton" v-if="expandBtnState">
      <div class="expandGradient" v-if="expandState == 1"></div>
      <div
        class="expandBtn expandDown"
        v-if="expandState == 1"
        @click.stop="expandFn(1)"
      >
        展开<span></span>
      </div>
      <div class="expandBtn expandUp" v-else @click.stop="expandFn(2)">
        收起<span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandCollapse',
  data() {
    return {
      expandState: 1,
      expandHeightstate: false,
      expandBtnState: false
    }
  },
  props: {
    expandTitle: {
      type: String,
      default: '个人介绍'
    },
    expandContent: {
      type: String
    },
    viewHeight: {
      type: Number,
      default: 126
    }
  },
  methods: {
    expandFn(e) {
      if (e === 1) {
        this.expandState = 2
        this.expandHeightstate = true
      } else {
        this.expandState = 1
        this.expandHeightstate = false
      }
    }
  },
  mounted() {
    let maHeight = this.$refs.expandma.offsetHeight
    if (maHeight > this.viewHeight) {
      this.expandBtnState = true
    }
  }
}
</script>

<style scoped>
.expandContent {
  display: block;
  font-size: 13px;
  line-height: 20.66px;
  max-height: 120px;
  overflow: hidden;
}
.expandHeightAuto {
  max-height: inherit;
}
.span-name {
  color: #a9a7aa;
}
.expandButton {
  text-align: center;
  padding-top: 10px;
  position: relative;
}
.expandBtn {
  position: relative;
  border: 1px #999 solid;
  height: 21px;
  line-height: 21px;
  width: 54px;
  font-size: 11px;
  color: #999;
  display: inline-block;
  border-radius: 10px;
  text-align: left;
  padding-left: 8px;
}
.expandBtn span {
  position: absolute;
  width: 9px;
  height: 5px;
  background: url('../assets/images/application-study/icon-arrowDown.png')
    no-repeat;
  background-size: 100% auto;
  right: 6px;
  top: 7px;
}
.expandUp span {
  background: url('../assets/images/application-study/icon-arrowUp.png')
    no-repeat;
  background-size: 100% auto;
}
.expandGradient {
  position: absolute;
  width: 100%;
  height: 60px;
  left: 0;
  top: -60px;
  background: linear-gradient(0deg, #ffffff, rgba(255, 255, 255, 0));
}
</style>



// WEBPACK FOOTER //
// src/components/ExpandCollapse.vue